export default __webpack_public_path__ + "static/media/Nidhi Batavia.590672bc.jpg";